import html2pdf from 'html2pdf.js';

export const generatePDF = async (elementId, fileName = 'Rehber360_Rapor.pdf') => {
  const element = document.getElementById(elementId);
  
  if (!element) {
    console.error("PDF için hedef alan bulunamadı: ", elementId);
    return false;
  }

  // PDF için akıllı ayarlar
  const opt = {
    margin:       [10, 0, 10, 0], // Üst, Sağ, Alt, Sol boşluklar (mm)
    filename:     fileName,
    image:        { type: 'jpeg', quality: 1 },
    html2canvas:  { 
      scale: 2, 
      useCORS: true,
      backgroundColor: '#ffffff',
      // SİHİR 1: Mobilde bile olsak, PDF'i 1024px genişliğinde çizer ki masaüstü görünümü korunsun!
      windowWidth: 1024 
    },
    jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' },
    
    // SİHİR 2: GİYOTİN ETKİSİNİ BİTİREN KOD
    // avoid: '.avoid-break' ve 'tr' sayesinde -> Tablo satırlarını (tr) ve bizim "avoid-break" class'ı verdiğimiz hiçbir div'i ortadan ikiye KESMEZ, bütün halinde alt sayfaya taşır.
    pagebreak:    { mode: ['css', 'legacy'], avoid: ['.avoid-break', 'tr', 'h2', 'h3', 'h4'] }
  };

  try {
    // html2pdf.js kendi içinde Promise yapısı kullanır
    await html2pdf().set(opt).from(element).save();
    return true;
  } catch (error) {
    console.error("PDF oluşturma hatası:", error);
    alert("PDF oluşturulurken bir hata meydana geldi.");
    return false;
  }
};